import { selectUseQueryService } from '@opengov/ogql-client/selectors';
import { EOgqlJobState, IOgqlJobResult } from '@opengov/ogql-types';
import { EQueryType } from '@opengov/reporting-types';
import { createSelector } from 'reselect';
import { composeEffects } from '../../../../module';
import { selectReportConfigWithMetadata } from '../../../reportExplorer/selectors/selectReportExplorerState';
import { DataTableStatus } from '../../../reportExplorer/types';
import { selectUseLargeScaleQueryLimit } from '../../flags';
import { runV0Query } from '../../reportConfiguration/effects/queries/runQueries';
import { selectIsInStandardReport } from '../../reportConfiguration/selectors';
import { selectBasicCalculation } from '../selectors';
import { basicCalculationActionCreators } from '../state';
import { showPermissionErrorToast } from '../../helpers/permissionErrorHelper';

export const basicCalculationEffects = composeEffects('basic-calculation', (compose) => ({
  getCalculationPreviewTableData: compose.statefulPayloadlessEffect(
    createSelector(
      [
        selectReportConfigWithMetadata,
        selectBasicCalculation,
        selectUseLargeScaleQueryLimit,
        selectUseQueryService,
        selectIsInStandardReport
      ],
      (
        currentReportConfiguration,
        calculationColumn,
        useLargeScaleQueryLimit,
        useQueryService,
        isStandardTemplate
      ) => ({
        currentReportConfiguration,
        calculationColumn,
        useLargeScaleQueryLimit,
        useQueryService,
        isStandardTemplate
      })
    ),
    async ({
      currentReportConfiguration,
      calculationColumn,
      useLargeScaleQueryLimit,
      useQueryService,
      isStandardTemplate
    }) => {
      basicCalculationActionCreators.updateCalculationPreviewTableStatus(DataTableStatus.Loading);
      return runV0Query({
        reportId: currentReportConfiguration.reportId,
        queryType: EQueryType.calculationPreview,
        body: { column: calculationColumn },
        useLargeScaleQueryLimit,
        useQueryService,
        isStandardTemplate
      })
        .then((result) => {
          return handleBasicCalculationPreviewQueryResult(result);
        })
        .catch(showPermissionErrorToast);
    }
  )
}));

export const handleBasicCalculationPreviewQueryResult = (result: IOgqlJobResult) => {
  switch (result.state) {
    case EOgqlJobState.finished: {
      basicCalculationActionCreators.setQueryResult(result);
      basicCalculationActionCreators.updateCalculationPreviewTableStatus(DataTableStatus.Current);
      break;
    }
    case EOgqlJobState.failed: {
      basicCalculationActionCreators.updateCalculationPreviewTableStatus(DataTableStatus.Current);
      return result;
    }
    default:
      return result;
  }
};
